// extracted by mini-css-extract-plugin
export var blue = "_3y-h";
export var brand = "_3y-d";
export var darkGrey = "_3y-g";
export var disabled = "_3y-6";
export var disabledSubtle = "_3y-7";
export var error = "_3y-8";
export var green = "_3y-i";
export var grey = "_3y-f";
export var icon = "_3y-0";
export var inherit = "_3y-c";
export var lightGrey = "_3y-e";
export var orange = "_3y-k";
export var pink = "_3y-m";
export var primary = "_3y-1";
export var purple = "_3y-n";
export var quaternary = "_3y-4";
export var quinary = "_3y-5";
export var red = "_3y-l";
export var secondary = "_3y-2";
export var success = "_3y-b";
export var tertiary = "_3y-3";
export var warning = "_3y-9";
export var warningSecondary = "_3y-a";
export var white = "_3y-o";
export var yellow = "_3y-j";